import fileDownload from 'js-file-download';
import axios from 'axios';

export function downloadBundledFile(fileUrl, downloadName) {
    axios.get(fileUrl, {responseType: 'blob'}).then( form => fileDownload(form.data, downloadName));
}
